export const SCH = {
  nav: "nav-system-change-history",
  page: "system-change-history-page",
  title: "system-change-history-title",
  banner: "system-change-history-banner",
  table: "system-change-history-table",
  empty: "system-change-history-empty",
  row: "system-change-history-row",
  addBtn: "system-change-history-add-btn",
  form: "system-change-history-form",
  formTitle: "system-change-history-field-title",
  formSummary: "system-change-history-field-summary",
  formSha: "system-change-history-field-sha",
  formTag: "system-change-history-field-tag",
  formStatus: "system-change-history-field-status",
  formSave: "system-change-history-save-btn",
  formCancel: "system-change-history-cancel-btn",
};
